import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import GridItem from "./Item";

class BannerGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            ...props
        };

        this.fetchBannerSlide = this.fetchBannerSlide.bind(this);
    }

    componentDidMount() {
        this.setState({
            restUrl: localStorage.getItem("restUrl"),
            isLoading: true
        });
        if (this.props.slides.length < 1) {
            this.fetchBannerSlide();
        }
    }

    fetchBannerSlide() {
        axios
            .get(`/api/banner/${this.props.sliderid}`)
            .then(bannerResult => {
                this.setState({
                    isLoading: false,
                    ...bannerResult.data.response[0].banner
                });
            })
            .catch(err => {
                this.setState({
                    isLoading: false
                });
                console.error(err);
            });
    }

    render() {
        return (
            <div className="row justify-content-center">
                {!this.state.isLoading &&
                    this.state.slides.map((slide, index) => {
                        return (
                            <GridItem
                                className={`${this.props.itemClassName} ${
                                    this.state.slides.length === 6
                                        ? "divisible-by-3"
                                        : ""
                                }`}
                                key={`collection-item-${index}`}
                                restUrl={this.state.restUrl}
                                bannerName={this.state.name}
                                {...slide}
                            />
                        );
                    })}
            </div>
        );
    }
}

BannerGrid.defaultProps = {
    slides: [],
    itemClassName: ""
};

BannerGrid.propTypes = {
    sliderid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    slides: PropTypes.array,
    pause_time_between_transitions: PropTypes.number,
    slide_transition_speed: PropTypes.number,
    itemClassName: PropTypes.string,
    restUrl: PropTypes.string
};

export { BannerGrid };
